import { Badge } from '@/components/typography';

type ProductAreaBadgeProps = {
  name: string;
  disabled?: boolean;
  onClose: () => void;
};

const ProductAreaBadge = ({ name, disabled = false, onClose }: ProductAreaBadgeProps) => {
  return (
    <Badge color="info" closable showTooltip={false} disabled={disabled} onClose={onClose}>
      {name}
    </Badge>
  );
};

export default ProductAreaBadge;
